import { Button, Checkbox, Form, Input, message, Popconfirm } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../../server";
import { CloseCircleOutlined } from "@ant-design/icons";
import TakePhoto from "../../../controls/take-photo/take-photo";
import UploadPhoto from "../../../controls/take-photo/upload-photo";

const CatalogGroup = ({ id, onClose, onDelete }) => {
  const [item, setItem] = useState({ idx: 0, active: true });
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [imageVersion, setImageVersion] = useState(Date.now());
  const [takePhoto, setTakePhoto] = useState(false);
  const [uploadPhoto, setUploadPhoto] = useState(false);

  const getData = () => {
    if (id) {
      setLoading(true);
      serverFetch(`Catalog/Groups/${id}`)
        .then(data => {
          setItem(data);
          form.setFieldsValue(data);
          setLoading(false);
        })
        .catch(e => {
          setLoading(false);
          message.error(e.userMessage);
        });
    } else {
      form.setFieldsValue(item);
    }
  };

  useEffect(getData, [id, form]);

  const onValuesChange = (value) => setItem({ ...item, ...value });

  const onClosePhoto = (refresh) => {
    setTakePhoto(false);
    refresh && getData();
  };

  const onCloseUpload = (refresh) => {
    setUploadPhoto(false);
    refresh && getData();
  };

  const handlePhoto = (file = null) => {
    const formData = new FormData();
    if (file) formData.append('file', file, file.name);
    serverFetch(`Catalog/Groups/photo/${id}`, { method: "PUT", body: formData })
      .then(() => {
        setImageVersion(Date.now());
        onClosePhoto(true);
      })
      .catch(e => message.error(e.userMessage));
  };

  const onSave = () => {
    form.validateFields().then(() => {
      setLoading(true);
      serverFetch("Catalog/Groups", { method: id ? "PUT" : "POST", bodyData: item })
        .then(() => onClose(true))
        .catch(e => {
          setLoading(false);
          message.error(e.userMessage);
        });
    });
  };

  const onDeleteGroup = () => {
    setLoading(true);
    serverFetch(`Catalog/Groups/${id}`, { method: "DELETE" })
      .then(() => {
        message.success("Группа удалена");
        onClose();
        onDelete && onDelete();
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  return (
    <div className="sport-modal">
      <div
        className="sport-modal-overlay"
        onMouseDown={e => e.target === e.currentTarget && onClose(false)}
      >
        <div
          className="sport-modal-content"
          onMouseDown={e => e.stopPropagation()}
        >
          <div className="sport-modal-title">
            <span>Группа</span>
            <CloseCircleOutlined className="sport-section-title-close" onClick={() => onClose()} />
          </div>
          <Form form={form} onValuesChange={onValuesChange} layout="vertical" colon={false} disabled={loading}>
            <Form.Item name="active" valuePropName="checked" label=" "><Checkbox>Активный</Checkbox></Form.Item>
            <div style={{ display: "flex", gap: "16px" }}>
              <div style={{ flex: 1 }}>
                <Form.Item label="Порядок" name="idx" rules={[{ required: true, message: "Введите порядок" }]}>
                  <Input type="number" />
                </Form.Item>
                <Form.Item label="Наименование" name="name" rules={[{ required: true, message: "Введите наименование" }]}>
                  <Input />
                </Form.Item>
                <Form.Item label=" ">
                  <div style={{ display: "flex", gap: "8px" }}>
                    <Button className="sport-btn" onClick={onSave} loading={loading}>Сохранить</Button>
                    {id ? (
                      <Popconfirm title="Удалить группу?" description="Это действие нельзя отменить. Все элементы группы также будут удалены." onConfirm={onDeleteGroup} okText="Да" cancelText="Нет">
                        <Button className="sport-btn" danger loading={loading}>Удалить</Button>
                      </Popconfirm>
                    ) : null}
                    <Button className="sport-btn" onClick={() => onClose()}>Закрыть</Button>
                  </div>
                </Form.Item>
              </div>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
                <img src={item?.imageId ? `${process.env.REACT_APP_API_BASE_URL}/api/image/${item.imageId}.jpg` : "/images/picture.svg"}
                  alt="group" style={{ width: 150, height: 150, objectFit: "contain" }} />
                {id ? (
                  <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
                    <img src="/images/photo.svg" alt="take-photo" style={{ width: 32, cursor: "pointer" }} onClick={() => setTakePhoto(true)} />
                    <img src="/images/upload-photo.svg" alt="upload-photo" style={{ width: 32, cursor: "pointer" }} onClick={() => setUploadPhoto(true)} />
                    {item?.imageId && <img src="/images/delete-button.svg" alt="delete-photo" style={{ width: 32, cursor: "pointer" }} onClick={() => handlePhoto()} />}
                  </div>
                ) : null}
              </div>
            </div>
            {takePhoto && <TakePhoto onClose={onClosePhoto} onSave={handlePhoto} />}
            {uploadPhoto && <UploadPhoto onClose={onCloseUpload} onSave={handlePhoto} />}
          </Form>
        </div>
      </div>
    </div>
  );
};

export default CatalogGroup;

